import { type ComponentProps, type FC, Suspense, lazy } from "react";
import Modal from "@root/shared/components/Modal";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { type ScoutsSavePrevSearchCondition } from "@clientFrontend/features/scout/types/scoutsSavePrevSearchCondition";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import type { ScoutsSavePrevSearchConditionForm as ScoutsSavePrevSearchConditionFormProps } from "@clientFrontend/features/scout/components/ScoutsSavePrevSearchConditionForm";
import * as styles from "./styles.css";

const ScoutsSavePrevSearchConditionForm = lazy(() =>
  retryLazyLoad<ComponentProps<typeof ScoutsSavePrevSearchConditionFormProps>>({
    fn: () =>
      import("@clientFrontend/features/scout/components/ScoutsSavePrevSearchConditionForm").then(
        (module) => ({ default: module.ScoutsSavePrevSearchConditionForm }),
      ),
  }),
);

type Props = {
  prevSearchCondition: string;
  form: ScoutsSavePrevSearchCondition;
  isModalOpen: boolean;
  onOpenModal: () => void;
  onCloseModal: () => void;
};

export const Presentation: FC<Props> = ({
  prevSearchCondition,
  form,
  isModalOpen,
  onOpenModal,
  onCloseModal,
}) => (
  <>
    <div className={styles.card}>
      <p className={styles.cardTitle}>前回検索した条件：{prevSearchCondition}</p>
      <Button
        type="button"
        onClick={onOpenModal}
        theme="tertiary"
        size="small"
        className={styles.searchConditionButton}
      >
        <Icon name="save" />
        この条件を新規で保存
      </Button>
    </div>
    <Modal
      isShow={isModalOpen}
      onClose={onCloseModal}
      headerTitle="検索条件保存"
      footerContentStyle="button"
      footerContent={<FooterContent onCancel={onCloseModal} />}
    >
      <Suspense fallback={null}>
        <ScoutsSavePrevSearchConditionForm {...form} />
      </Suspense>
    </Modal>
  </>
);

const FooterContent: FC<{ onCancel: () => void }> = ({ onCancel }) => (
  <div className={styles.footerButtonArea}>
    <Button type="button" theme="secondary" onClick={onCancel} className={styles.footerButton}>
      キャンセル
    </Button>
    <Button
      type="submit"
      theme="primary"
      className={styles.footerButton}
      form="client_saved_scout_search_condition"
    >
      保存する
    </Button>
  </div>
);
